import React, { useCallback } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

export const PipelineRemovalModal = ({
  error = null,
  pipeline = null,
  onPipelineVersionsRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const onConfirm = useCallback(() => {
    onPipelineVersionsRemoved(pipeline?.pipelineId, pipeline?.workspaceId, pipeline?.versions);
  }, [onPipelineVersionsRemoved, pipeline?.pipelineId, pipeline?.versions, pipeline?.workspaceId])

  return (
    <ConfirmationDialog
      title="Delete Selected Version(s)"
      confirmButtonText="Delete Selected"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-versions-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1">
        <Label>
          The selected pipeline version(s) will be deleted from Wallaroo. Are you sure?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the selected version(s). Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default PipelineRemovalModal;
